// Live Interview integrity-event vocabulary - one place for the labels the
// recruiter sees (live alerts in RecruiterRoomPage, the Integrity Events
// section on SummaryPage), so the same signal reads the same everywhere.
// Wording for the camera/mic detections matches Proctored Interview's
// ScorecardPage (INTEGRITY_EVENT_LABELS there).
//
// Where each event comes from:
//  - camera/mic detections - useIntegrityMonitor, during the call
//    (multiple_audio_sources in AI mode only - see LiveInterviewRoomPage)
//  - tab_hidden / *_attempt / multi_screen_detected during the call -
//    LiveInterviewRoomPage, human mode
//  - permission / location / display checks + the info events - PreJoinPage

export const LIVE_INTEGRITY_EVENT_LABELS: Record<string, string> = {
  // Camera / mic detections
  multiple_persons: 'Multiple persons detected',
  no_person: 'No person in view',
  electronic_device: 'Electronic device detected',
  looking_away: 'Looking away from screen',
  camera_blocked: 'Camera blocked',
  multiple_audio_sources: 'Multiple audio sources detected',
  // Browser behaviour during the call
  tab_hidden: 'Switched tab or left the interview window',
  copy_attempt: 'Tried to copy (blocked)',
  cut_attempt: 'Tried to cut (blocked)',
  paste_attempt: 'Tried to paste (blocked)',
  multi_screen_detected: 'Extra display detected',
  // Pre-join checks
  permission_denied: 'Camera / microphone permission denied',
  geolocation_denied: 'Location unavailable',
  // Informational (not flags)
  camera_mic_granted: 'Camera & microphone allowed',
  geolocation_captured: 'Location captured',
  integrity_monitor_armed: 'Integrity monitoring started',
}

// Recorded for the audit trail, but not suspicious - shown without the
// warning styling and not counted as flags.
const INFO_EVENT_TYPES = new Set(['camera_mic_granted', 'geolocation_captured', 'integrity_monitor_armed'])

export function isIntegrityFlag(eventType: string): boolean {
  return !INFO_EVENT_TYPES.has(eventType)
}

export function integrityEventLabel(eventType: string): string {
  return LIVE_INTEGRITY_EVENT_LABELS[eventType] || eventType.replace(/_/g, ' ')
}
